/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_No_SubscriptionInputs */

const en_settings_billing_no_subscription = /** @type {(inputs: Settings_Billing_No_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No active subscription`)
};

const zh_settings_billing_no_subscription = /** @type {(inputs: Settings_Billing_No_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无活跃订阅`)
};

/**
* | output |
* | --- |
* | "No active subscription" |
*
* @param {Settings_Billing_No_SubscriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_billing_no_subscription = /** @type {((inputs?: Settings_Billing_No_SubscriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_No_SubscriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_billing_no_subscription(inputs)
	return zh_settings_billing_no_subscription(inputs)
});
export { settings_billing_no_subscription as "settings.billing.no_subscription" }